import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Layout from './components/Layout';
import Stoc from './pages/Stoc';
import Alerte from './pages/Alerte';
import Magazii from './pages/Magazii';
import Materiale from './pages/Materiale';
import Produse from './pages/Produse';
import ProduseFinite from './pages/ProduseFinite';
import Furnizori from './pages/Furnizori';
import Miscari from './pages/Miscari';
import Comenzi from './pages/Comenzi';
import Utilizatori from './pages/Utilizatori';
import ImportDate from './pages/ImportDate';
import DraggableModals from './components/DraggableModals';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  const [, setUser] = useState(null);

  return (
    <BrowserRouter>
      <DraggableModals />
      <Routes>
        <Route path="/login" element={<Login onLogin={setUser} />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Stoc />} />
          <Route path="produse-finite" element={<ProduseFinite />} />
          <Route path="alerte" element={<Alerte />} />
          <Route path="magazii" element={<Magazii />} />
          <Route path="materiale" element={<Materiale />} />
          <Route path="produse" element={<Produse />} />
          <Route path="furnizori" element={<Furnizori />} />
          <Route path="miscari" element={<Miscari />} />
          <Route path="comenzi" element={<Comenzi />} />
          <Route path="utilizatori" element={<Utilizatori />} />
          <Route path="import-date" element={<ImportDate />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
